import React from 'react'
import Header from "./Header";
import style from "../CSS/Style.module.css";
import { Link, useNavigate } from "react-router-dom";
export default function ClientSucessPage() {
  return (
    <>
    <Header />
    <body>
        <div className={style.main_content}>
          <div className={style.breadcrumps}>
            <ul className={style.breadcrumpsItems}>
              <li>
                <Link to="/dashboard">Home </Link>
              </li>

              <li>
            
                <Link to="/addclient">Add Client</Link>
              </li>
            </ul>
          </div><div className={style.contentwrpper}>
           
             
             <div className={style.contentwrpperForm}>
            <h1><center>Client details added sucessfully</center></h1> </div>19943 9135
            <div>
            <Link to="/addproject">
        <button>Add Project</button>
      </Link>
      <Link to="/addclient">
        <button>Add Client</button>
      </Link>
      <Link to="/invoice">
        <button>Create Invoice</button>
      </Link>
           </div></div></div></body>
    </>
  )
}
